import { PrimaryGeneratedColumn, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Index } from 'typeorm';

// This entity holds the working hours of an unit on a specific date if there is any deviation for the default worling hours
@Entity('m_unit_day_hours')
export class UnitDayHourEntity {
    @PrimaryGeneratedColumn('increment',{
        name:'id'
    })
    id: string;

    @Column('varchar', {
        nullable: false,
        length: 5,
        name: 'unit_id'
    })
    unitId: string;

    @Column('date', {
        nullable: false,
        name: 'date'
    })
    date: string;
    // The effected date on which the default plant working hours are being changed

    @Column('text', {
        nullable: false,
        name: 'working_hours'
    })
    workingHours: string;
    // the default decided working hours of the plant i.e the general 8 hours in the CSV like 9,10,11,12,13,14,15,16,17,18 -- in 24 hours format

    @Column('text', {
        nullable: false,
        name: 'actual_working_hours'
    })
    actualWorkingHours: string;
    // the actual real working hours of the plant i.e the early working hours as well as late working hours in the CSV like 9,10,11,12,13,14,15,16,17,18 -- in 24 hours format

    @Column('boolean',{
        nullable:false,
        default: true,
        name:'is_active'
    })
    isActive:boolean;

    @CreateDateColumn({name: 'created_at'})
    createdAt: Date;

    @UpdateDateColumn({name: 'updated_at'})
    updatedAt: Date;
}